import { InjectionToken } from "@angular/core";

/**
 * interfaces
 */
import { ILoadingControlService, ILoadingHttpControlService, ILoadingStatusService } from "../interfaces";

/**
 * Injection token for manual loading control service
 * @constant {InjectionToken<ILoadingControlService>} LOADING_CONTROL
 * @description Token used to inject manual loading control services
 */
export const LOADING_CONTROL = new InjectionToken<ILoadingControlService>('LOADING_CONTROL');

/**
 * Injection token for HTTP loading control service
 * @constant {InjectionToken<ILoadingHttpControlService>} LOADING_HTTP_CONTROL
 * @description Token used to inject HTTP loading control and management services
 */
export const LOADING_HTTP_CONTROL = new InjectionToken<ILoadingHttpControlService>('LOADING_HTTP_CONTROL');

/**
 * Injection token for loading status service
 * @constant {InjectionToken<ILoadingStatusService>} LOADING_IS_LOADING
 * @description Token used to inject loading status management services
 */
export const LOADING_IS_LOADING = new InjectionToken<ILoadingStatusService>('LOADING_IS_LOADING');
